// extracted by mini-css-extract-plugin
module.exports = {"embeddedpayment":"EmbeddedPaymentMethodGroup_embeddedpayment__K4seS"};